<template>
    <table class="statistic">
      <statistic-header
        :controls-data="statisticControls.data"
        :active="statisticControls.current"
        @onClick="handleClick"
      />
      <template v-if="!reqPending">
        <tr

          v-for="(item, key) in statisticControls.data[statisticControls.current].data"
          :key="key"
        >
          <td :class="`statistic__item statistic__item--${key}`">
            <ul :class="`${key}-list`">
              <li :class="`${key}-list__item-header`">
                {{item.header}}
              </li>
              <li :class="`${key}-list__item ${key}-list__item--posts`">
                {{item.posts}}
              </li>
              <li :class="`${key}-list__item ${key}-list__item--likes`">
                {{item.likes}}
              </li>
              <li :class="`${key}-list__item ${key}-list__item--reposts`">
                {{item.reposts}}
              </li>
            </ul>
          </td>
        </tr>
      </template>

      <template v-else>
        <table-preloader />
      </template>
    </table>
</template>

<script>
import router from '@/router';

// components
import StatisticHeader from './components/StatisticHeader.vue';
import TablePreloader from '@/components/preLoaders/tablePreloader.vue';

// api
import { getTodayTrustApi, getWeekTrustApi } from '@/api/statistic';

// models
import { statisticModel } from './statisticModel';

export default {
  name: 'VisualStatistics',
  data() {
    return {
      statisticControls: statisticModel,
      reqPending: false,
      days: 7,
      thread_id: process.env.VUE_APP_THREAD_ID,
    };
  },
  computed: {
    activeMethod() {
      return this.statisticControls.data[this.statisticControls.current].method;
    },
  },
  methods: {
    getTodayTrust() {
      this.reqPending = true;

      const params = {
        thread_id: this.thread_id,
      };

      getTodayTrustApi(params)
        .then((resp) => {
          this.setData(resp);
          this.reqPending = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            router.push('/login');
          }
          this.reqPending = false;
          return err;
        });
    },
    getWeekTrust() {
      this.reqPending = true;

      const params = {
        thread_id: this.thread_id,
        days: this.days,
      };

      getWeekTrustApi(params)
        .then((resp) => {
          this.setData(resp);
          this.reqPending = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            router.push('/login');
          }

          this.reqPending = false;
          return err;
        });
    },
    setData(resp) {
      this.statisticControls.data[this.statisticControls.current].data.total = {
        header: 'Всего',
        posts: resp.data.total,
        likes: resp.data.poststats.likes,
        reposts: resp.data.poststats.reposts,
      };

      this.setTonalData(resp.data, 'positive');
      this.setTonalData(resp.data, 'netural');
      this.setTonalData(resp.data, 'negative');
    },
    setTonalData(data, tonal) {
      this.statisticControls.data[this.statisticControls.current].data[tonal] = {
        header: null,
        posts: data.trust_extended[1][tonal].total,
        likes: data.trust_extended[1][tonal].likes,
        reposts: data.trust_extended[1][tonal].reposts,
      };
    },
    handleClick(key) {
      this.statisticControls.current = key;
    },
  },
  watch: {
    activeMethod(method) {
      this[method]();
    },
    $route() {
      this[this.activeMethod]();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this[this.activeMethod]();
    });
  },
  components: {
    StatisticHeader,
    TablePreloader,
  },
};
</script>

<style scoped>
  @import "./css/style.css";
</style>
